<template>
  <div class="collection">
    <RefiningItem v-for="item of list" :key="item.id" v-bind="item"/>
  </div>
</template>
<script>
import RefiningItem from '../../../components/RefiningItem'
import { get } from '../../../utils/request'
import { get as getUser } from '../../../utils/token'
import { isAndroid } from '../../../utils/utils'
export default {
  components: {
    RefiningItem
  },
  data () {
    return {
      list: [],
      isAndroid: isAndroid()
    }
  },
  mounted () {
    this.getCollectionList()
  },
  methods: {
    getCollectionList () {
      const user = getUser('user')
      const promise = get({
        url: `/user/getStoreList/${user.id}`
      })
      promise.then(res => {
        const { data: { code, detail } } = res
        if (Object.is(code, 200)) {
          this.list = detail.map(item => item.curriculum)
        }
      }).catch(() => {
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.collection {
  width: 100%;
  box-sizing: border-box;
  padding: 12px 3.47%;
  height: 100vh;
  overflow-y: scroll;
  background:rgba(242,242,247,1);
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-content: baseline;
}
</style>
